import React from "react";
import PropTypes from "prop-types";

import ProgressBar from 'components/ProgressBar';

const EndQuizBlockModal = ({ quizType, blockQuestionsLength, totalAnswered }) => {
  const answeredLabel = quizType === 'tutor' ? 'attempted' : 'answered';
  return (
    <div>
      <ProgressBar className="mb-2" percent={totalAnswered / blockQuestionsLength * 100} />
      <strong>You&rsquo;ve {answeredLabel} {totalAnswered} out of {blockQuestionsLength} questions.</strong>
      <br />
      You cannot answer or change your response to questions after submitting.
    </div>
  );
};

EndQuizBlockModal.propTypes = {
  quizType: PropTypes.string.isRequired,
  blockQuestionsLength: PropTypes.number,
  totalAnswered: PropTypes.number
};

export default EndQuizBlockModal;
